<div class='multiselect-dropdown' [ngClass]="{'has-focus': hasFocus, 'error': isError && formControl.invalid}" (focus)='hasFocus=true' tabindex='0'
  (blur)='onFocusLost()'>
  <!--  <div class="placeholder" *ngIf="isSelectionEmpty()">{{placeholder}}</div>-->
  <div class='selection-box' (click)='toggleDropDown()'>
    @for (item of selection; track getIdentifier(item)) {
      <div class='item-tag'><span>{{getCaption(item)}}</span>
      @if (isDeletable(item)) {
        <div class='icone-suppr' (click)='supprimer(item, $event)'><i
        class='icon icon-x'></i></div>
      }
    </div>
  }
</div>
<div class='button-dropdown' (click)='toggleDropDown()' [ngClass]="{'is-active': isDropDownVisible}">
  <i class='icon icon-chevron-down'></i>
</div>
@if (isDropDownVisible) {
  <div class='select-area'>
    @for (item of proposedValues; track getIdentifier(item)) {
      <div>
        <div class='proposed-value' (click)='addItemToSelection(item); closeDropDown()'><span>{{getCaption(item)}}</span>
      </div>
    </div>
  }
</div>
}
</div>
